import { fetchResource, updateResource } from './fetchResource';

export function fetchUserBehavior() {
  return dispatch => fetchResource(dispatch, 'user_behaviors', 'USER_BEHAVIOR_FETCHED');
}
